import { LegumeInterface } from "../_legumes";
import fetchUtil from "./_fetchUtil";

export default class Http {
    private _fetch = new fetchUtil()
    private _baseUrl = `/api/jardin/legumes`

    getAll = (): Promise<Response> => this._fetch.get(`${this._baseUrl}`)
    get = (id: LegumeInterface['id']): Promise<Response> => this._fetch.get(`${this._baseUrl}/${id}`)
    post = (): Promise<Response> => this._fetch.post(`${this._baseUrl}`)
    put = (id: LegumeInterface['id'], data: Partial<LegumeInterface>): Promise<Response> => this._fetch.put(`${this._baseUrl}/${id}`, data)

    uploadImage = (id: LegumeInterface['id'], form: FormData): Promise<Response> => this._fetch.upload(`${this._baseUrl}/${id}/image`, form)
    removeImage = (id: LegumeInterface['id']) => this._fetch.delete(`${this._baseUrl}/${id}/image`)


    delete = (id: LegumeInterface['id']): Promise<Response> => this._fetch.delete(`${this._baseUrl}/${id}`)

}